import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { usePassword } from "../context/PasswordContext";

const PasswordModal = () => {
  const [password, setPassword] = useState("");
  const {
    passwordModal,
    passwordError,
    verifyPassword,
    closePasswordModal,
    authorizedSeries,
  } = usePassword();
  const navigate = useNavigate();

  // Check for existing authorization when modal opens
  useEffect(() => {
    if (passwordModal.isOpen && passwordModal.seriesId) {
      const existingAuth = authorizedSeries.find(
        (item) => item.seriesId === passwordModal.seriesId
      );

      if (existingAuth) {
        if (passwordModal.redirectUrl) {
          navigate(passwordModal.redirectUrl);
        }
        closePasswordModal();
      }
    }
  }, [
    passwordModal.isOpen,
    passwordModal.seriesId,
    authorizedSeries,
    navigate,
    closePasswordModal,
    passwordModal.redirectUrl,
  ]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const success = await verifyPassword(password);
    if (success && passwordModal.redirectUrl) {
      navigate(passwordModal.redirectUrl);
    }
  };

  // Don't render if already authorized
  if (
    !passwordModal.isOpen ||
    authorizedSeries.some((item) => item.seriesId === passwordModal.seriesId)
  ) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75">
      <div className="bg-gray-900 p-8 rounded-lg max-w-md w-full border border-gray-700">
        <h2 className="text-white text-xl font-bold mb-4">Password Required</h2>
        <p className="text-gray-300 mb-6">
          "{passwordModal.seriesTitle}" is password protected. Please enter the
          password to continue.
        </p>

        <form onSubmit={handleSubmit}>
          <input
            type="password"
            placeholder="Enter password"
            className="w-full p-3 bg-gray-800 text-white rounded mb-4 focus:outline-none focus:ring-2 focus:ring-yellow-400"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
          />

          {passwordError && (
            <p className="text-red-500 mb-4">{passwordError}</p>
          )}

          <div className="flex justify-end space-x-4">
            <button
              type="button"
              onClick={closePasswordModal}
              className="px-4 py-2 bg-gray-700 text-white rounded hover:bg-gray-600 transition"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-yellow-400 text-black font-bold rounded hover:bg-yellow-300 transition"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PasswordModal;
